export default __webpack_public_path__ + "static/media/discover.b28e780e.gif";